import { v4 as uuid } from "uuid";
import { CORRELATION_STORAGE_KEY } from "./constants";

export function generateCorrelationId(): string {
  return uuid();
}

export function currentCorrelationId(): string {
  const existing = sessionStorage.getItem(CORRELATION_STORAGE_KEY);
  if (existing) return existing;
  const fresh = generateCorrelationId();
  sessionStorage.setItem(CORRELATION_STORAGE_KEY, fresh);
  return fresh;
}

export function rotateCorrelationId(): string {
  const fresh = generateCorrelationId();
  sessionStorage.setItem(CORRELATION_STORAGE_KEY, fresh);
  return fresh;
}
